function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.506,
    height: 18,
    viewBox: "0 0 15.506 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18523"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "user (4)",
    transform: "translate(-3.94 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1132",
    cx: 4.179,
    cy: 4.179,
    r: 4.179,
    transform: "translate(7.514 2)",
    style: {
      fill: "#fcca92"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59601",
    d: "M19.009 23.955a1.919 1.919 0 0 1-1.491.707H5.869a1.929 1.929 0 0 1-1.89-2.308L4 22.239c.489-2.449 1-4.989 2.938-6.724a1.93 1.93 0 0 1 2.237-.193 5.179 5.179 0 0 0 5.027 0 1.93 1.93 0 0 1 2.237.193c1.935 1.736 2.449 4.275 2.938 6.724l.026.116a1.922 1.922 0 0 1-.394 1.6z",
    transform: "translate(0 -4.662)",
    style: {
      fill: "#ff8b00"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.bfbd3ad3c637738df4e9fc5bad2e23d3.svg";
export { ForwardRef as ReactComponent };